import { render, staticRenderFns } from "./ApplicantStudents.vue?vue&type=template&id=284b446f&"
import script from "./ApplicantStudents.vue?vue&type=script&lang=js&"
export * from "./ApplicantStudents.vue?vue&type=script&lang=js&"
import style0 from "./ApplicantStudents.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports